import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import clsx from "clsx";
import { useVisualRefresh } from "../internal/base-component/use-visual-refresh.js";
import styles from "./styles.css.js";
export default function WidgetContainerHeader({ handle, children, settings }) {
    const isVisualRefresh = useVisualRefresh();
    return (_jsxs("div", { className: clsx(styles.header, isVisualRefresh && styles.refresh), children: [_jsx("div", { className: clsx(styles.fixed, styles.handle), children: handle }), _jsx("div", { className: clsx(styles.flexible, styles["header-content"]), children: children }), settings ? _jsx("div", { className: clsx(styles.fixed, styles.settings), children: settings }) : null] }));
}
